import * as allSelectors from './selectors';

export { actions, reducer } from './duck';
export { default as sagas } from './sagas';

export const selectors = allSelectors;
